import {useDeviceSize} from './../theme/helpers';
import {logout} from '../../redux/actions/login';
import {useDialog} from '../components/modal/dialog';
import {useDispatch} from 'react-redux';
import {DeviceSize} from '../theme/helpers';
import {useNavigation, useRoute} from '@react-navigation/native';
import {Screens} from '../../shared/routing';
import {useModal} from '../components/modal';

export const useLogoutDialog = (): (() => Promise<void>) => {
  const dialog = useDialog();
  const dispatch = useDispatch();
  const deviceSize = useDeviceSize();
  const {navigate} = useNavigation();
  const route = useRoute();
  const modal = useModal();
  modal.clear();

  return async () => {
    dialog.showDialog({
      message: 'Вы действительно хотите выйти?',
      actions: [
        {
          title: 'Да',
          type: 'primary',
          closeModal: true,
          onPress: () => {
            dispatch(logout());
          },
        },
        {
          title: 'Нет',
          type: 'transparent',
          closeModal: true,
        },
      ],
      messageStyle: deviceSize === DeviceSize.desktop ? {marginBottom: 42} : {marginBottom: 30},
    });
  };
};
